import { useEffect, useState } from 'react';
import { authAxios } from '../../services/AxiosService';
import { Button, Card, CardBody, CardHeader, Col, Container, Navbar, NavbarBrand, Row } from 'reactstrap';
import { FaPrint } from 'react-icons/fa';
import * as React from 'react';
import Select from 'react-select';

interface IEligibilityAppealsData {
  month: number;
  appealsCount: number;
  approvedCount: number;
  refusedCount: number;
}

export const EligibilityAppeals = () => {
  const [eligibilityAppealsData, setEligibilityAppealsData] = useState<IEligibilityAppealsData[]>([]);

  const generateYears = (start: number, end: number) => {
    const range = [];
    for (let i = start; i >= end; i--) {
      range.push({ val: i, display: i.toString() });
    }
    return range;
  };

  const yearValues = generateYears(new Date().getFullYear(), 2000);

  const monthList = [
    { val: 1, display: 'January' },
    { val: 2, display: 'February' },
    { val: 3, display: 'March' },
    { val: 4, display: 'April' },
    { val: 5, display: 'May' },
    { val: 6, display: 'June' },
    { val: 7, display: 'July' },
    { val: 8, display: 'August' },
    { val: 9, display: 'September' },
    { val: 10, display: 'October' },
    { val: 11, display: 'November' },
    { val: 12, display: 'December' },
  ];

  const currentYear = yearValues[0];
  const [year, setYear] = useState<number | undefined>(currentYear ? currentYear.val : 0);

  useEffect(() => {
    authAxios.get(`/api/reports/eligibility-appeals?yearInt=${year}`).then((response) => {
      setEligibilityAppealsData(response.data);
    });
  }, [year]);

  const getAppealsCount = (data: IEligibilityAppealsData | undefined) => {
    return data ? data.appealsCount : 0;
  };

  const getApprovedCount = (data: IEligibilityAppealsData | undefined) => {
    return data ? data.approvedCount : 0;
  };

  const getRefusedCount = (data: IEligibilityAppealsData | undefined) => {
    return data ? data.refusedCount : 0;
  };

  return (
    <div>
      <Navbar color={'light'} light={true} expand={'xs'} className={'border-bottom sticky-top'}>
        <Row className={'flex-fill'}>
          <Col md={3} xl={2}>
            <NavbarBrand>Eligibility Appeals</NavbarBrand>
          </Col>
          <Col className={'d-flex'}>
            <Button className={'ml-auto'} color={'warning'} onClick={() => window.print()}>
              Print <FaPrint />
            </Button>
          </Col>
        </Row>
      </Navbar>
      <Container className={'container--no-margin-print'}>
        <Row className={'my-5 '}>
          <Col>
            <Card className={'no-print'}>
              <CardHeader>Select Year</CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Select
                      name={'year'}
                      options={yearValues}
                      value={yearValues.find((y) => y.val === year)}
                      onChange={(value: any) => {
                        setYear(value?.val);
                      }}
                      getOptionValue={(option: any) => option.val}
                      getOptionLabel={(option: any) => option.display}
                      isClearable={true}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col className={'no-print'}>
            <p className={'text-muted'}>
              *This report includes all files that were in Board Review at some point during the year selected. For
              consistency, the counts for Approved and Refused are based on when the file entered Board Review (eg: if a
              file enters Board Review on December 2023 and is approved in Jan 2024, it will count as approved for
              December 2023). Files with the Duty Counsel file type are not included.
            </p>
          </Col>
        </Row>
        <div className={'report my-5 mx-3'}>
          <header className={'report-header'}>
            <h2 className={'text-center'}>Eligibility Appeals</h2>
          </header>
          <table className={'report1'}>
            <thead>
              <tr>
                <th className={'headerspan'} colSpan={2} />
                <th className={'header'} colSpan={3}>
                  Appeals
                </th>
                <th className={'header'} colSpan={3}>
                  Approved
                </th>
                <th className={'header'} colSpan={3}>
                  Refused
                </th>
              </tr>
            </thead>
            <tbody>
              {monthList.map((m, index) => {
                return (
                  <tr key={m.display}>
                    <th className={'headerspan'} colSpan={2}>
                      {m.display}
                    </th>
                    <td className={'report-row'} colSpan={3}>
                      {getAppealsCount(eligibilityAppealsData.find((b) => b.month === m.val))}
                    </td>
                    <td className={'report-row'} colSpan={3}>
                      {getApprovedCount(eligibilityAppealsData.find((b) => b.month === m.val))}
                    </td>
                    <td className={'report-row'} colSpan={3}>
                      {getRefusedCount(eligibilityAppealsData.find((b) => b.month === m.val))}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Container>
    </div>
  );
};
